// extracted by mini-css-extract-plugin
export default {"dark":"ProfileWallet_dark__dBOyG","light":"ProfileWallet_light__Qjl5t","common_profile_wallet":"ProfileWallet_common_profile_wallet__DKNLK"};